import React, { useEffect, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function Timeinfo(props) {
const [Time,setTime]=useState(props.Tdata[1])
const [dur,setDur]=useState(0)
const [status,setStatus]=useState("static")
const [statcol,setStatcol]=useState("red")
const [test,setTest]=useState(0)

useEffect(()=>{
  let netDuration=props.Tdata[0]*1000+props.Tdata[1]*1000+props.Tdata[2]*props.Tdata[0]*1000
  setStatus("running")
  setStatcol("green")
  setTimeout(() => {
    setStatus("static")
    setStatcol("red")
  }, netDuration);
},[props.entgl])

useEffect(()=>{
  setTime(props.Tdata[1])
},[props.Tdata[1],props.entgl])

useEffect(()=>{
  if(Time>0){
    const timer=setInterval(() => {
      setTime((Time)=>Time-1)
    }, 1000);
    return()=>{
      clearInterval(timer)
    }
  }
  return()=>{}
},[props.Tdata[1],Time,props.entgl])

useEffect(()=>{
  setDur(0-props.Tdata[1])
},[props.Tdata[0],props.entgl])


useEffect(()=>{
  if(dur<props.Tdata[0]*props.Tdata[2]){
    const timer=setInterval(() => {
      setDur((dur)=>dur+1)
    }, 1000);
    return()=>{
      clearInterval(timer)
    }
  }
  return()=>{}
},[props.Tdata[0],dur,props.entgl])

  return (
    <div  className='Tbox flex'>
      <div  className='Tinfo'>Animation name : <span style={{color:'green'}}>{props.MSG}</span></div>
      <div className='Tinfo'>Config : <span style={spanstyle}> {props.Tdata[3]}</span> <span style={spanstyle}> {props.Tdata[4]}</span> </div>
      <div className='Tinfo'>Status :<span style={{color:`${statcol}`}}> {status}</span></div>
      <div className='Tinfo'>Starts in :{Time}s  {Time>0?<CircularProgress size={13}/>:<FontAwesomeIcon icon={faCheck} />}</div>
      <div className='Tinfo'>Duration : {dur>0?dur:0}s { dur<props.Tdata[0]*props.Tdata[2]?<CircularProgress  size={13}/>:<FontAwesomeIcon icon={faCheck} />}</div>
    </div>
  )
}

const spanstyle={
  padding:"2px",
  color:'#007ACC',
  borderRadius:"5px"
}